export default "__VITE_ASSET__acadea6b__"